// Categorical series colors for the Reporting page's hand-rolled SVG charts — reuses the same
// Tailwind palette already used across the app's existing charts (SLAChart.tsx, Dashboard.tsx
// summary card icons): blue, emerald, amber, purple, red, slate, cyan, pink.
export const SERIES_COLORS = [
  '#3b82f6', // blue-500
  '#10b981', // emerald-500
  '#f59e0b', // amber-500
  '#9333ea', // purple-600
  '#ef4444', // red-500
  '#06b6d4', // cyan-500
  '#ec4899', // pink-500
  '#64748b', // slate-500
];

export const STATUS_COLORS: Record<string, string> = {
  open: '#eab308', // yellow-500 (matches SLAChart "at risk")
  in_progress: '#f97316', // orange-500
  closed: '#22c55e', // green-500 (matches SLAChart "on track")
  reopened: '#dc2626', // red-600 (matches SLAChart "breached")
};
